import {Component, OnInit} from '@angular/core';
import {AlertService} from "../services";
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import {MatDialog} from "@angular/material/dialog";
import {ComponentTitleService} from "../services/componentTitle.service";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";

import { locale as polish } from './i18n/pl';
import {fuseAnimations} from "../../../@fuse/animations";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Service} from "../models/service";
import {MessageTemplate} from "../models/messageTemplate";
import {MessageTemplateService} from "../services/messageTemplate.service";
import {NotificationAccountService} from "../services/notificationAccount.service";
import {NotificationAccount} from "../models/notificationAccount";
import {Notification} from "./model/notification";
import {MessageTemplateList} from "../models/messageTemplateList";
import {NotificationService} from "./service/notification.service";

@Component({
    templateUrl: './notificationForm.component.html',
    styleUrls: ['./notificationForm.component.scss'],
    animations   : fuseAnimations
})

export class NotificationFormComponent implements OnInit {

    form: FormGroup;
    loading = false;
    submitted = false;
    id: string;
    isAddMode: boolean;
    dialogRef: any;
    availableServices: Service[];
    notification: Notification;
    templates: MessageTemplateList;
    hide: boolean = true;
    reasons: any[] = [
        {
            "id": "incoming-reservation",
            "name": "Incoming reservation"
        },
        {
            "id": "promotional-campaign",
            "name": "Promotional campaign"
        },
    ];

    constructor(
        public _matDialog: MatDialog,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private _matSnackBar: MatSnackBar,
        private notificationService: NotificationService,
    ) {
        this.translationLoader.loadTranslations(polish);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Notifications');
    }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];
        this.isAddMode = !this.id;

        if (this.isAddMode) {
            this.componentTitleService.addPart('New');
        } else {
            this.componentTitleService.addPart('Edit');
        }

        this.form = this.formBuilder.group({
            reason: ['', Validators.required],
            hours: ['24', Validators.required],
            enabled: [false],
            template: [null, Validators.required],

        });

        this.templates = this.route.snapshot.data.messageTemplates;

        if (!this.isAddMode) {
            this.notification = this.route.snapshot.data.notification;
            this.f.reason.setValue(this.notification.reason);
            this.f.hours.setValue(this.notification.hours);
            this.f.enabled.setValue(this.notification.enabled);
            this.f.template.setValue(this.notification.template.id);
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        // this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;

        if (this.isAddMode) {
            this.createNotificationAccount();
        } else {
            this.updateNotificationAccount();
        }
    }

    private createNotificationAccount() {
        this.notificationService.create(this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this._matSnackBar.open('Notification added successfully', 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-success']
                    });
                    this.router.navigate(['.', { relativeTo: this.route }]);
                },
                error => {
                    this.loading = false;
                    this._matSnackBar.open('Notification creation error - ' + error, 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-error']
                    });
                });
    }

    private updateNotificationAccount() {
        this.notificationService.update(this.id, this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this._matSnackBar.open('Update successful', 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-success']
                    });
                    this.router.navigate(['..', { relativeTo: this.route }]);
                },
                error => {
                    this._matSnackBar.open('Notification update error - ' + error, 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-error']
                    });
                    this.loading = false;
                });
    }
}
